import { render, staticRenderFns } from "./process_item_param.vue?vue&type=template&id=4132d854&scoped=true"
import script from "./process_item_param.vue?vue&type=script&lang=js"
export * from "./process_item_param.vue?vue&type=script&lang=js"
import style0 from "./process_item_param.vue?vue&type=style&index=0&id=4132d854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4132d854",
  null
  
)

export default component.exports